import { render, staticRenderFns } from "./HomeHealthIcon.vue?vue&type=template&id=1a09df1c&scoped=true&"
import script from "./HomeHealthIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HomeHealthIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a09df1c",
  null
  
)

export default component.exports